/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

export default {
  computed: {
    getItemForm () {
      // console.log(this.selectedItem)
      return this.selectedItem
    },
    passRule () {
      if (this.nullablePassword === !0) {
        return undefined
      }
      const r = ['confirmed:password_confirmation']
      !this.getItemForm?.id && r.push('required')
      return r.join('|')
    },
    passConfirmRule () {
      if (this.nullablePassword === !0) {
        return undefined
      }
      const r = ['confirmed:password']
      !this.getItemForm?.id && r.push('required')
      return r.join('|')
    }
  }
}
